export const messageError = '―';
